import { RouteRecordRaw } from 'vue-router';
import CorporateCareTypeSelection from '@/apps/corporateOnboarding/careType/CorporateCareTypeSelection.vue';
import BackupCareRequest from '@/apps/corporateOnboarding/backupCare/BackupCareRequest.vue';
import { requireSeeker } from '../guards/authGuards';
import corporateOnboardingGuard from '../guards/corporateOnboardingGuard';
import combineGuards from '../guards/helpers';
import CorporateOnboardingGuided from '@/apps/corporateOnboarding/guided/CorporateOnboardingGuided.vue';
import CorporateGuidedSelection from '@/apps/corporateOnboarding/guided/steps/CorporateGuidedSelection.vue';
import CorporateGuidedLocation from '@/apps/corporateOnboarding/guided/steps/CorporateGuidedLocation.vue';
import CorporateGuidedCareNearYou from '@/apps/corporateOnboarding/guided/steps/CorporateGuidedCareNearYou.vue';

const corporateOnboardingGuards = combineGuards([requireSeeker, corporateOnboardingGuard]);

/**
 * Corporate Onboarding Routes
 *
 * Entry at /corporate-onboarding is resolved by corporateOnboardingGuard (guided vs care-type/backup-care).
 * Do not add a static redirect here — Vue Router skips beforeEnter on redirecting routes, which would
 * send variant users straight to care-type and skip the guided flow.
 */
export const corporateOnboardingRoutes = [
  {
    path: '/corporate-onboarding',
    name: 'corporate_onboarding',
    beforeEnter: corporateOnboardingGuards,
  },
  {
    path: '/corporate-onboarding/care-type',
    name: 'corporate_onboarding_care_type',
    component: CorporateCareTypeSelection,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
  },
  {
    path: '/corporate-onboarding/backup-care',
    name: 'corporate_onboarding_backup_care',
    component: BackupCareRequest,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
  },
];

export const corporateOnboardingGuidedRoutes: RouteRecordRaw[] = [
  {
    path: '/corporate-onboarding/guided',
    component: CorporateOnboardingGuided,
    meta: { simpleHeader: true },
    beforeEnter: corporateOnboardingGuards,
    children: [
      {
        path: '',
        redirect: { name: 'corporate-onboarding-guided-selection' },
      },
      {
        path: 'selection',
        name: 'corporate-onboarding-guided-selection',
        component: CorporateGuidedSelection,
        meta: {
          routeStepper: {
            stepLabel: 'Selection',
          },
        },
      },
      {
        path: 'location',
        name: 'corporate-onboarding-guided-location',
        component: CorporateGuidedLocation,
        meta: {
          routeStepper: {
            stepLabel: 'Location',
            breadcrumbLabel: 'Back',
          },
        },
      },
      {
        path: 'care-near-you',
        name: 'corporate-onboarding-guided-care-near-you',
        component: CorporateGuidedCareNearYou,
        meta: {
          routeStepper: {
            stepLabel: 'Care near you',
          },
        },
      },
    ],
  },
];
